/*
 * Copyright (c) 2019 by Felix Heim, felix@ask-ev.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('UserManagementSearch', UserManagementSearch);

    UserManagementSearch.$inject = ['$resource'];

    function UserManagementSearch($resource) {
        var resourceUrl =  'api/_search/users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
